<template>
  <v-card class="my-1 elevation-0">
    <v-card-title>
      <h5>Pendentes</h5>
    </v-card-title>
    <div v-if="loading"  class="d-flex align-center justify-center" style="height: 200px;">
      <v-progress-circular indeterminate color="primary" size="32" /> 
    </div>
    <v-card-text v-else>
      <v-radio-group 
        v-model="visaoGraficoQuantidades" 
        row
        class="mb-0 ml-2"
      >
        <v-radio
          label="Valores"
          value="valor"
        />
        <v-radio
          label="Porcentagem"
          value="porcentagem"
        />
      </v-radio-group>
      <highcharts 
        :options=chartQuantidadesOptions 
        :deepCopyOnUpdate="false" 
      />

      <highcharts 
        :options=chartPrazoMedioOptions 
        :deepCopyOnUpdate="false" 
      />
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: "DashboardServicosVisaoAneelCardPendentes",
  props: {
    dados: {
      type: Object,
      required: true,
    },
    competencias: {
      type: Array,
      required: true
    },
    prazoReguladoServico: {
      type: Number,
      required: true,
    },
    exportingOptions : {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    visaoGraficoQuantidades: "valor",
    chartQuantidadesOptions: {},
    chartPrazoMedioOptions: {},
  }),
  computed: {
    categories() {
      // Solicitação do Tiburcio: deve haver um range de pelo menos 12 meses na visualização do dashboard
      if (this.competencias.length < 12) {
        const startDate = dayjs(this.competencias[0], 'MM/YYYY').format("YYYY-MM"); 
        const endDate   = dayjs(this.competencias[0], 'MM/YYYY').add(11, 'month').format("YYYY-MM");
  
        return generateMonthlyDateRangeArray(startDate, endDate, 'YYYY-MM');
      }

      return this.competencias;
    },
  },
  mounted() {
    this.setChartsOptions();
  },
  methods: {
    setChartsOptions() {
      this.setChartQuantidadesOptions();
      this.setChartPrazoMedioOptions();
    },
    setChartQuantidadesOptions() {
      this.chartQuantidadesOptions = {
        chart: {
          type: 'column',
          zoomType: 'xy',
          height: 200,
          animation: false,
        },
        colors: [
          this.$vuetify.theme.themes.light.primary,
          "#FF5252"
        ],
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        xAxis: {
          categories: this.categories,
          crosshair: true,
          title: { 
            text: "Competência" 
          }
        },
        yAxis: {
          title: { text: null },
          labels: { 
            format: this.visaoGraficoQuantidades === 'porcentagem' ? '{value}%' : '{value}'
          },
        },
        plotOptions: {
          series: {
            animation: false,
          },
          column: {
            stacking: this.visaoGraficoQuantidades === 'porcentagem' ? 'percent' : 'normal',
          }
        },
        tooltip: { 
          shared: true,
        },
        lang: {
          noData: "Sem dados para exibição"
        },
        series: [
          {
            name: "Quant. prazo",
            animation: false,
            data: this.categories
              .map(category => {
                return category in this.dados 
                  ? { x: this.categories.indexOf(category), y: Number(this.dados[category].qtd_prazo) } 
                  : { x: this.categories.indexOf(category), y: null }
              })
              // .filter(val => val !== null && val.y !== null && val.y > 0)
          },
          {
            name: "Quant. fora prazo (SERV_013)",
            animation: false,
            data: this.categories
              .map(category => {
                return category in this.dados 
                  ? { x: this.categories.indexOf(category), y: Number(this.dados[category].qtd_fora_prazo) } 
                  : { x: this.categories.indexOf(category), y: null }
              })
              // .filter(val => val !== null && val.y !== null && val.y > 0)
          }
        ],
        exporting: this.exportingOptions,
      };
    },
    setChartPrazoMedioOptions() {
      this.chartPrazoMedioOptions = {
        chart: {
          type: 'spline',
          zoomType: 'x',
          height: 200,
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: true },
        xAxis: {
          categories: this.categories,
          crosshair: true,
          title: { 
            text: "Competência"
          }
        },
        yAxis: {
          title: { text: null }
        },
        tooltip: { 
          shared: true,
          valueDecimals: 2
        },
        plotOptions: {
          series: {
            marker: { 
              // enabledThreshold: 12,
              radius: 2,
            },
            animation: false,
            connectNulls: true,
          }
        },
        lang: {
          noData: "Sem dados para exibição"
        },
        series: [
          {
            name: "PM Fora Prazo (SERV_014)",
            animation: false,
            color: "#FF5252",
            data: this.categories
              .map(category => {
                return category in this.dados 
                  ? { x: this.categories.indexOf(category), y: Number(this.dados[category].pm_fora_prazo) } 
                  : { x: this.categories.indexOf(category), y: null }
              })
              // .filter(val => val !== null && val.y !== null && val.y > 0)
          },
          {
            name: "PM Total (SERV_007)",
            animation: false,
            color: this.$vuetify.theme.themes.light.primary,
            data: this.categories
              .map(category => {
                return category in this.dados 
                  ? { x: this.categories.indexOf(category), y: Number(this.dados[category].pm_total) } 
                  : { x: this.categories.indexOf(category), y: null }
              })
              // .filter(val => val !== null && val.y !== null && val.y > 0)
          },
          {
            name: "Prazo Regulado",
            animation: false,
            color: "#4CAF50",
            data: this.categories
              .map(category => {
                return { x: this.categories.indexOf(category), y: this.prazoReguladoServico };
              })
          }
        ],
        exporting: this.exportingOptions,
      };
    },
  },
  watch: {
    dados() {
      this.setChartsOptions();
    },
    visaoGraficoQuantidades() {
      this.setChartQuantidadesOptions();
    },
  },
}
</script>

<style></style>
